import { Button } from "reactstrap";
import { Rate } from "rsuite";

import AppBadge from "../../../elements/AppBadge";
import AppSpinner from "../../../elements/AppSpinner";
import { CloudApp, GlobalApp } from "../../../types/GlobalInterfaces";
import useGrowthCloudStoreApp from "../../../hooks/useGrowthCloudApp";

interface Props {
  app: CloudApp | GlobalApp;
  isAdmin: boolean;
}

const AppDetailHeader = ({ app, isAdmin }: Props) => {
  const { extendedApp, installID, addingApp, uninstallingApp } =
    useGrowthCloudStoreApp({ app, disabled: false });

  return (
    <div className="tw:flex tw:flex-col tw:md:flex-row tw:items-start tw:w-full tw:pb-6 tw:gap-5 tw:border-b tw:border-superlight">
      {extendedApp.Icon && (
        <div className="tw:p-1">
          {typeof extendedApp?.Icon === "object" ? (
            <img
              className="tw:w-20 tw:h-20 tw:object-contain"
              alt="App Icon"
              src={extendedApp?.Icon?.PublicURL || ""}
            />
          ) : typeof extendedApp.Icon === "string" ? (
            <img
              className="tw:w-20 tw:h-20 tw:rounded"
              alt="App Icon"
              src={extendedApp?.Icon || ""}
            />
          ) : null}
        </div>
      )}
      <div className="tw:flex tw:flex-col">
        <h3 className="tw:mb-0 tw:flex tw:items-center">
          {extendedApp?.Name ? extendedApp.Name : "(No Name)"}

          {app?.Version && (
            <AppBadge
              fontSize={10}
              backgroundColor={extendedApp?.isOutdated ? "#FFDEBF" : "#81E3A6"}
              color={extendedApp?.isOutdated ? "#FF8A1C" : "#229F50"}
              className="tw:ml-2"
            >
              v{app.Version}
            </AppBadge>
          )}
        </h3>
        <p className="tw:mb-1">{extendedApp?.Summary}</p>
        <div className="tw:flex tw:items-center tw:gap-4">
          {extendedApp?.MSTags?.length && (
            <div>
              {extendedApp.MSTags.map((tag: any) => {
                return (
                  <AppBadge
                    key={tag}
                    fontSize={12}
                    borderRadius={4}
                    color="#424342"
                    className="tw:my-1"
                  >
                    {tag.Title}
                  </AppBadge>
                );
              })}
            </div>
          )}
          {extendedApp?.Rating && (
            <>
              <Rate
                defaultValue={extendedApp?.Rating}
                color="orange"
                size="xs"
                allowHalf
                readOnly
              />
              <span className="text-primary">
                ({extendedApp?.Reviews?.length ? extendedApp.Reviews.length : 0}{" "}
                reviews)
              </span>
            </>
          )}
        </div>
      </div>
      <Button
        color="primary"
        className="tw:flex tw:justify-center tw:items-center tw:sm:ml-auto tw:text-nowrap"
        disabled={
          !!installID ||
          addingApp ||
          uninstallingApp ||
          !isAdmin ||
          !!extendedApp?.isSameCloud ||
          !!extendedApp?.isCloudApp
        }
        onClick={
          extendedApp.isOutdated || !extendedApp.isInstalled
            ? () => extendedApp.installFunc(extendedApp.id)
            : () => extendedApp.uninstallFunc(extendedApp.id)
        }
      >
        {installID === extendedApp.id || addingApp || uninstallingApp ? (
          <AppSpinner size="sm" color="white" />
        ) : (
          extendedApp.buttonText
        )}
      </Button>
    </div>
  );
};

export default AppDetailHeader;
